// cores base
const colors = {
  primary: '#1C4B75',
  secondary: '#E5EAEE',
  secondary_light: '#D8DDE0',
  error: '#F64E60',
  error_light: '#FFF3F3',
  danger: '#df4759',
  success: '#099b94',
  success_light: '#F2FCFA',
  info: '#29096c',
  warning: '#FFC107',
  light: '#D8EBFF',
  dark: '#464E5F',
  background: '#FFFFFF',
  white: '#fff',
  light_blue: '#266ca8',
  dark_blue: '#143857',
  button_menu: 'rgba(255, 255, 255, 0.15)',
  medium_gray: '#B5B5C3',
  placeholder: '#888',
  gray: '#494950',
  light_gray: '#F9F9F9',
  black: '#212529',
  light_yellow: '#FFF4DE',
  light_red: '#FFE2E5',
  light_green: '#C9F7F5',
  yellow_indicator: '#FDEAA7',
  orange: '#FFC300',
  yellow_rating_star: '#FFA800',
  yellow: '#FFFF00',
  yellow_bange: '#ffff1967',
  checklist_gray: '#747A87',
  grayish_blue: '#EAEBED',
  blueish_purple: '#29096C',
  light_blueish_purple: '#4800A3',
  lighter_green: '#38E07E',
  fleet_management_gray: '#808080',
};

// botão
const button = {
  colors: {
    primary: {
      background: colors.primary,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.primary,
      },
      light: {
        background: colors.light,
        text: colors.primary,
      },
    },
    secondary: {
      background: colors.secondary,
      text: colors.dark,
      outline: {
        background: colors.white,
        text: colors.dark,
      },
    },
    danger: {
      background: colors.danger,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.danger,
      },
      light: {
        background: colors.light_red,
        text: colors.danger,
      },
    },
    error: {
      background: colors.error,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.error,
      },
      light: {
        background: colors.light_red,
        text: colors.error,
      },
    },
    success: {
      background: colors.success,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.success,
      },
      light: {
        background: colors.light_green,
        text: colors.success,
      },
    },
    info: {
      background: colors.info,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.info,
      },
    },
    warning: {
      background: colors.warning,
      text: colors.dark,
      outline: {
        background: colors.white,
        text: colors.warning,
      },
      light: {
        background: colors.light_yellow,
        text: colors.dark,
      },
    },
    warningBange: {
      background: colors.yellow_bange,
      text: colors.dark,
      outline: {
        background: colors.white,
        text: colors.warning,
      },
      light: {
        background: colors.light_yellow,
        text: colors.dark,
      },
    },
    light: {
      background: colors.light,
      text: colors.light_blue,
      outline: {
        background: colors.white,
        text: colors.light_blue,
      },
    },
    purple: {
      background: colors.grayish_blue,
      text: colors.light_blueish_purple,
      outline: {
        background: colors.white,
        text: colors.light_blueish_purple,
      },
    },
    dark: {
      background: colors.dark,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.dark,
      },
    },
    white: {
      background: colors.white,
      text: colors.dark,
      outline: {
        background: colors.white,
        text: colors.dark,
      },
    },
    transparent: {
      background: 'transparent',
      text: colors.white,
    },
    raster: {
      background: 'transparent',
      text: colors.danger,
    },
    preload: {
      background: colors.blueish_purple,
      text: colors.white,
      outline: {
        background: colors.white,
        text: colors.light_blueish_purple,
      },
      light: {
        background: colors.light_blueish_purple,
        text: colors.white,
      },
    },
  },
  spacing: {
    sm: '5px',
    md: '10px',
    lg: '15px',
  },
};

// cores de badge
const badge = {
  colors: {
    'Ordem de coleta': button.colors.primary,
    'Liberado coleta': button.colors.primary,
    'Em viagem': button.colors.info,
    'Aguardando descarregamento': button.colors.warning,
    'Em análise': button.colors.warning,
    'Carregamento finalizado': button.colors.primary,
    'Documentação emitida': button.colors.info,
    Finalizado: button.colors.success,
    Cancelado: button.colors.error,
    'Aguardando carregamento': button.colors.primary,
    'Aguardando emissão': button.colors.primary,
    Transbordado: button.colors.success,
    Bloqueado: button.colors.error,
    ...button.colors,
  },
};

// spacing com função compatível MUI
const BASE_SPACING = 8;
const spacing = Object.assign(
  (factor) => `${BASE_SPACING * (Number(factor) || 0)}px`,
  {
    buttonY: {
      xs: '2px',
      sm: '5px',
      md: '10px',
      lg: '15px',
    },
    buttonX: {
      xs: '4px',
      sm: '10px',
      md: '30px',
      lg: '25px',
    },
  }
);

// Tema final com palette MUI compatível
const theme = {
  palette: {
    common: {
      white: colors.white,
      black: colors.black,
    },
    primary: {
      main: colors.primary,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.secondary,
      contrastText: colors.dark,
    },
    error: {
      main: colors.error,
      contrastText: colors.white,
    },
    success: {
      main: colors.success,
      contrastText: colors.white,
    },
    warning: {
      main: colors.warning,
      contrastText: colors.dark,
    },
    info: {
      main: colors.info,
      contrastText: colors.white,
    },
    text: {
      primary: colors.dark,
      secondary: colors.medium_gray,
    },
    background: {
      default: colors.background,
    },
  },
  spacing,
  text: {
    sizes: {
      title: '2rem',
      subtitle: '24px',
      header: '1.125rem',
      body: '1rem',
      regular: '0.875rem',
      medium: '0.8125rem',
      label: '0.75rem',
      little: '0.625rem',
    },
  },
  borderRadius: {
    input: '3px',
    button: '20px',
  },
  colors: {
    ...colors,
    button: button.colors,
    badge: badge.colors,
  },
  shadow: '0 1px 1px rgba(0, 0, 0, 0.16)',
};

// Compat layer for legacy styled-components code still using theme.newTheme
theme.newTheme = theme;

export default theme;
